<template>
    <v-container>
    <v-row
            class="flex-child"
    >
        <v-col
        >

<!--            <v-card-->
<!--                    class="mx-auto pa-4"-->
<!--                    max-width="400"-->
<!--            >-->
<!--                <v-card-title>Timer</v-card-title>-->

<!--                <v-card-text>-->
                <Timer v-bind:time-length="sharedState.shortBreakDuration"
                       v-bind:primary-color="'var(--v-primary-lighten2)'"
                       v-on:on-completed="startFocusInterval"
                       v-show="isShortBreakInterval()"
                />
                <Timer v-bind:time-length="sharedState.longBreakDuration"
                       v-bind:primary-color="'var(--v-primary-lighten2)'"
                       v-on:on-completed="startFocusInterval"
                       v-show="isLongBreakInterval()"
                />
                <Timer v-show="isFocusInterval()"
                       v-bind:time-length="sharedState.focusDuration"
                       v-bind:primary-color="'var(--v-primary-base)'"
                       v-on:on-completed="startBreakInterval"
                />
<!--                </v-card-text>-->
<!--            </v-card>-->
        </v-col>
    </v-row>
    </v-container>
</template>

<script>
  import Timer from '../components/Timer.vue'
  import {db, auth} from '../main'
  import * as moment from 'moment'
  import { store } from "../store";

  export default {
    name: "Focus",
    components: {
      Timer
    },
    data: function () {
      return {
        interval: 'focus',
        count: 0,
        startOnce: false,
        totalFocusedInSeconds: 0,
        user: auth.currentUser,
        states: {
          fetchingToday: false
        },
        sharedState: store.state.pomodoro,
        isLoggedIn: false,
        dateTimeFormat: 'YYYY-MM-DD HH:mm:ss Z',
        focusIntervalStartTime: null
      }
    },
    methods: {
      isFocusInterval: function () {
        return this.interval === 'focus';
      },

      isShortBreakInterval: function () {
        return this.interval === 'shortBreak'
      },

      isLongBreakInterval: function () {
        return this.interval === 'longBreak'
      },

      startFocusInterval: function (timeSpent) {
        this.interval = 'focus';

        this.focusIntervalStartTime = moment().format(this.dateTimeFormat);

        this.$ga.event('Engagement', 'Completed Break', timeSpent);

        this.notifyFocusStarted();

        this.startOnce = true;
      },

      startBreakInterval: function (timeSpent) {
        this.count++;

        this.totalFocusedInSeconds += timeSpent;

        if (this.isLoggedIn)
          this.saveToFirestore();
        else
          this.$storage.set(moment().format('YYYY-MM-DD'), timeSpent);

        this.$ga.event('Engagement', 'Completed Focus', timeSpent);

        if (this.count % 4 === 0) {
          this.interval = 'longBreak'
        } else {
          this.interval = 'shortBreak'
        }

        this.notifyBreakStarted();

        this.startOnce = true;
      },

      playSound: function () {
        var audio = new Audio(require('../assets/bell.mp3'));
        audio.play().catch(function () {
          console.log('Failed to play sounds');
        });
      },

      notifyFocusStarted: function () {
        if (!this.startOnce) {
          return;
        }

        this.$notification.show('Start to work!', {
          body: ''
        }, {});

        this.playSound();
      },

      notifyBreakStarted: function () {
        if (!this.startOnce) {
          return;
        }

        this.$notification.show('Times up!', {
          body: 'Take a break.'
        }, {});

        this.playSound();
      },

      saveToFirestore: function () {
        const today = moment();

        console.log('Saving seconds ' + this.totalFocusedInSeconds);

        db.collection('history').add({
          date: today.format("YYYY-MM-DD"),
          week: today.week(),
          year: today.year(),
          seconds: this.totalFocusedInSeconds,
          user: '/users/' + auth.currentUser.uid,
          start: this.focusIntervalStartTime,
          end: today.format(this.dateTimeFormat)
        });
      }
    },
    mounted: function () {
      this.$ga.page('/focus');

      this.startFocusInterval();

      auth.onAuthStateChanged(user => {
        this.isLoggedIn = !!user;
      });
    }
  }
</script>

<style scoped>
    p {
        text-align: center;
    }
</style>
